"use client"

import { PageMaxWidth } from "@/components"
import { Button, Text } from "@/elements"

export type WizardFooterProgress = {
  show: boolean
  progress: number
}

interface Props {
  nextOnClick?: () => void
  nextSecondaryOnClick?: () => void
  nextSecondaryText?: string
  nextText?: string
  nextMutating?: boolean
  centeredText?: string
  CustomButton?: React.FC
  progressBar?: WizardFooterProgress
}

export const WizardFooter: React.FC<Props> = ({
  nextOnClick,
  nextText,
  nextMutating = false,
  nextSecondaryOnClick,
  nextSecondaryText,
  centeredText,
  CustomButton,
  progressBar,
}) => {
  return (
    <div className="fixed z-20 mx-auto w-full border-t border-bg-3 bg-bg-1">
      {progressBar?.show && (
        <>
          {Boolean(progressBar?.progress && progressBar.progress > 0 && progressBar?.progress < 100) ? (
            <div className="relative h-[3px] w-full bg-bg-3">
              <div className="absolute h-full bg-primary-3" style={{ width: `${progressBar.progress}%` }} />
            </div>
          ) : (
            <div className="h-[3px] w-full" />
          )}
        </>
      )}
      <PageMaxWidth>
        <div className="relative flex w-full flex-col items-center justify-end gap-2 px-5 py-4 sm:flex-row sm:px-10">
          {nextSecondaryOnClick && nextSecondaryText && (
            <Button className="w-full sm:w-fit" onClick={nextSecondaryOnClick} variant="transparent">
              {nextSecondaryText}
            </Button>
          )}
          {Boolean(centeredText) && (
            <div className="absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 sm:block">
              <Text variant="body2" className="text-fg-2">
                {centeredText}
              </Text>
            </div>
          )}
          {Boolean(centeredText) && (
            <Text variant="body2" className="block text-fg-2 sm:hidden">
              {centeredText}
            </Text>
          )}
          {CustomButton ? (
            <CustomButton />
          ) : (
            <Button className="w-full sm:w-fit" loading={nextMutating} onClick={nextOnClick}>
              {nextText}
            </Button>
          )}
        </div>
      </PageMaxWidth>
    </div>
  )
}
